import { useState } from "react";

import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import DatePicker from "../../../components/DatePickerField.component";
import "react-datepicker/dist/react-datepicker.css";

import { Button as ButtonBootstrap } from "react-bootstrap";
import ProjectPlanner from "./ProjectPlanner";
import { useHistory } from "react-router";
import { useStyles } from "./Style";
import { Container } from "@material-ui/core";
import { connect } from "react-redux";
import { Col, Form, Modal, Row, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_PROJECT_PLANNER } from "../../../graphql/mutation";

import { GET_PROJECT_PLANNER, GET_WORKER_LIST } from "../../../graphql/queries";
import { LinearProgress } from "@material-ui/core";
import Swal from "sweetalert2";

const Homepage = ({ fullname, createNewProject }) => {
  const history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const [show, setShow] = useState(false);

  const [createProjectPlanner] = useMutation(CREATE_PROJECT_PLANNER);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // const formik = useFormik({
  //   initialValues: createNewProject,
  //   onSubmit: (values) => {
  //     console.log(values);
  // createProjectPlanner({
  //   variables: {
  //     ...values,
  //     assignee: values.assignee || 1,
  //   },
  // });
  //   },
  // });

  const {
    error: projectError,
    data: projectData,
    loading: projectLoading,
  } = useQuery(GET_PROJECT_PLANNER);

  const {
    error: workerError,
    data: workerData,
    loading: workerLoading,
  } = useQuery(GET_WORKER_LIST);

  if (projectLoading) return <LinearProgress />;

  if (workerLoading) return <LinearProgress />;

  // const getAssigneeID = projectData.findAllProjectPlanner
  //   .slice()
  //   .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
  //   .map(({ assignee }, key) => {
  //     console.log(assignee);
  //     // opt.reduce(function(o, e) {return o[e] = true, o}, {});
  //     return (
  //       <>
  //         <option value={assignee} key={key}>
  //           {assignee}
  //         </option>
  //       </>
  //     );
  //   });

  const getAllWorkerList = workerData.findAllUserWorker
    .slice()
    .sort(
      ({ fullname: fullnamePrev }, { fullname: fullnameCurrent }) =>
        fullnamePrev - fullnameCurrent
    );

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  return (
    <div className={classes.root}>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Insert a New Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            onSubmit={async (values) => {
              // console.log(values.createNewProject.assignee.join(", "));
              console.log(values);
              console.log(
                values.createNewProject.assignee.map((elem) =>
                  parseInt(elem, 10)
                )
              );

              let newArr = [];

              newArr.push(values);

              console.log(newArr[0]);

              let newAssignee = newArr[0].createNewProject.assignee.map(
                (elem) => parseInt(elem, 10)
              );

              console.log(newAssignee);

              delete newArr[0].createNewProject;

              console.log(newArr[0]);

              createProjectPlanner({
                variables: {
                  ...newArr[0],
                  assignee: newAssignee,
                  // assignee: assignee.concat(values.createNewProject.assignee)
                },
              });
              let timerInterval;
              Swal.fire({
                title: "Success!",
                text: "New project has been successfully created",
                timer: 2000,
                icon: "success",
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
                willClose: () => {
                  clearInterval(timerInterval);
                },
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  console.log("I was closed by the timer");
                }
              });
            }}
            initialValues={createNewProject}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <>
                <Form noValidate onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <Form.Group controlId="formGroupTitle">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter New Project Title"
                          name="title"
                          value={values.title}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group controlId="formGroupDesc">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Description Project"
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          style={{ height: "100px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group controlId="formGroupStartDate">
                        <Form.Label>Start Date</Form.Label>
                        <DatePicker
                          name="start_date"
                          value={values.start_date}
                          onChange={setFieldValue}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="formGroupDueDate">
                        <Form.Label>Due Date</Form.Label>
                        <DatePicker
                          name="due_date"
                          value={values.due_date}
                          onChange={setFieldValue}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group controlId="formGroupEmail">
                        <Form.Label>Assign Worker: </Form.Label>
                        <br />
                        {getAllWorkerList.map(({ id, fullname }, key) => {
                          return (
                            <>
                              <label key={key}>
                                <Field
                                  required
                                  type="checkbox"
                                  name="createNewProject.assignee"
                                  value={id.toString()}
                                  onChange={handleChange}
                                  className="p-auto"
                                />
                                {`         ${fullname}`}
                              </label>
                              <br />
                            </>
                          );
                        })}
                        {/* <Form.Control
                        as="select"
                        type="number"
                        name="assignee"
                        value={values.assignee}
                        onChange={handleChange}
                        custom
                      >
                        {getAssigneeID}
                      </Form.Control> */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Modal.Footer>
                    <ButtonBootstrap variant="secondary" onClick={handleClose}>
                      Close
                    </ButtonBootstrap>
                    <ButtonBootstrap
                      type="submit"
                      variant="primary"
                      onClick={handleClose}
                    >
                      Submit
                    </ButtonBootstrap>
                  </Modal.Footer>
                </Form>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <CssBaseline />
      <main className={classes.content}>
        <div />
        <Container maxWidth="lg" className={classes.container} className="p-0">
          <Grid container spacing={3}>
            {/* Jumbotron */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={`${fixedHeightPaper} justify-content-center`}>
                <h1 className="text-center">Welcome, {fullname}!</h1>
                <p className="text-center">
                  Welcome to planner configuration. Here you can create a new
                  project and submit it to supervisor.
                </p>
                <Button
                  variant="primary"
                  style={{ width: "200px" }}
                  className="mx-auto"
                  onClick={handleShow}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleClose();
                    }
                  }}
                  //   onClick={() => deleteProject({ variables: { id: d.id } })}
                >
                  Add a New Project
                </Button>
                {/* <ButtonNewProject /> */}
              </Paper>
            </Grid>
            {/* Recent Project */}
            <Grid item xs={12}>
              <ProjectPlanner />
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fullname: state.login.fullname,
    createNewProject: state.planner.createNewProject,
  };
};

export default connect(mapStateToProps, null)(Homepage);
